import React from 'react';
import { motion } from 'framer-motion';
export function Pain() {
  const pains = ['Llegas a clase sin saber exactamente qué secuencia vas a dar', 'Tus alumnos no progresan porque no hay un orden claro de contenidos', 'Tienes grupos con niveles mezclados y no sabes cómo manejarlos', 'Cuando hay feriado o ausencia pierdes la continuidad de la práctica', 'No puedes justificar un aumento de precio porque no tienes nada sistematizado', 'Absorbes el estrés y las emociones de tus alumnos sin darte cuenta', 'Nadie valora tu trabajo porque no se ve reflejado en resultados concretos'];
  return <section className="py-20 px-4 bg-white" data-id="element-160">
      <div className="max-w-3xl mx-auto" data-id="element-161">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center text-oscuro mb-12 leading-tight" data-id="element-162">
          Si eres profe de yoga, esto
          <br data-id="element-163" />
          te va a sonar conocido:
        </motion.h2>

        <div className="space-y-4 mb-12" data-id="element-164">
          {pains.map((pain, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex items-start gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors" data-id="element-165">
              <span className="text-xl flex-shrink-0 mt-1" data-id="element-166">❌</span>
              <p className="text-lg text-gray-700 font-medium leading-relaxed" data-id="element-167">
                {pain}
              </p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="text-center text-xl md:text-2xl text-terracota font-medium italic" data-id="element-168">
          "¿Cuántas clases más vas a improvisar?"
        </motion.p>
      </div>
    </section>;
}